import { render, staticRenderFns } from "./TableOfItems.vue?vue&type=template&id=e7f979b2&scoped=true"
import script from "./TableOfItems.vue?vue&type=script&lang=js"
export * from "./TableOfItems.vue?vue&type=script&lang=js"
import style0 from "./TableOfItems.vue?vue&type=style&index=0&id=e7f979b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f979b2",
  null
  
)

export default component.exports